<template>
  <div class="body-wrapper">
    <div class="table-wrapper">
      <spinner class="spinner" line-fg-color="#00796b" :size="100" :line-size="6" v-if="loading"></spinner>
      <div v-show="!loading">
        <div class="buttons-wrapper">
          <button
            class="btn btn-primary btn-new-apartment"
            @click="showModal('ModalContentAddVirtualMember')"
          >Novi korisnik blagajne</button>
          <button
            class="btn btn-primary btn-manual"
            @click="showModalWider('ModalContentAddVirtualMemberManual')"
          >
            <i class="fas fa-question"></i>
          </button>
          <button
            class="btn btn-primary btn-bulk-add"
            @click="showModalWider('ModalContentBulkAddVirtualMembers')"
          >Grupno dodavanje korisnika blagajne</button>
          <button class="btn btn-primary btn-mailer" @click="showModal('ModalContentEmail')">
            Pošalji email
            <i class="far fa-envelope"></i>
          </button>
        </div>
        <data-table
          :columns="tableColumns"
          :tableData="tableData"
          :options="tableOptions"
          :slotNameActionCommunityFinances="'action'"
          :slotTransactionsBalance="'balance'"
        ></data-table>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';
export default {
  components: {
    DataTable
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  mounted() {},
  async created() {
    //setting up table options and table column names
    this.initTable('communityFinancesTable');
    const vm = await this.getAllMembersForCommunityFinances(
      this.$store.getters.getActiveCommunity.id
    );
    this.setTableData({ tableName: 'virtualMembers', data: this.tableData });
  },
  methods: {
    ...mapActions('table', ['initTable', 'getAllMembersForCommunityFinances']),
    ...mapMutations('modal', ['showModal', 'showModalWider']),
    ...mapMutations('finances', ['setTableData'])
  }
};
</script>
<style lang="scss">
.body-wrapper {
  display: block;
  padding: 10px;
}

.table-wrapper {
  position: relative;
}

.buttons-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;

  button {
    margin-right: 16px;
  }

  .btn-new-apartment {
    // background: var(--primary-color);
    color: white;
    margin-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
  .btn-manual {
    // position: absolute;
    // width: 280px;
    // left: 564px;
    // z-index: 1;
    height: 36px;
    width: 36px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background: #348f83;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: none;
    // color: black;
    &:hover {
      background: #196358;
    }
  }
  .btn-mailer {
    // position: absolute;
    // left: 865px;
    // z-index: 1;
    width: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-bulk-add {
    // position: absolute;
    // left: 220px;
    // z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>